import Checkout from './Checkout'
import checkoutContainer from './checkoutContainer'

export default checkoutContainer(Checkout)
